import templateUrl from './resource-subcategory-details.html';

export const resourceSubcategoryDetailsComponent = {
    templateUrl,
    bindings: {
        details: '<'
    },

    controller: class ResourceSubcategoryDetailsComponent {

        constructor($state, ModalService, resourcesService, toastr, $stateParams){
            'ngInject';

            this.$state = $state;
            this.modalService = ModalService;
            this.resourcesService = resourcesService;
            this.toastr = toastr;
            this.$stateParams = $stateParams;
        }
        $onInit(){
            this.resourceId = this.$stateParams.resource_id;
        }

        getFormattedAddress(address) {
			if (address) {
				let addressDetails = [address.addressLine1];
				if (address.addressLine2) {
					addressDetails.push(address.addressLine2);
				}
				addressDetails.push(address.cityName);
				addressDetails.push(address.zipcode ? `${address.stateName} ${address.zipcode}` : address.stateName);
				return addressDetails.join(', ');
			}
			return "";
        }
        
        _onEditCategory(){
            this.$state.go('resourceSubCategoryEdit', {
                id: this.details.id,
                resource_id: this.resourceId
            });
        }

        onDeleteCategory(index){
            this.modalService.open({
				details: {
					bodyMessage: "Are you sure you want to delete this subcategory?"
				},
				buttons: [{
					name: 'no'
				}, {
					name: "yes",
					isPrimary: true,
					action: _delete.bind(this)
				}]
			});
			function _delete() {
                this.details.subCategoryList.splice(index, 1);
                this.resourcesService.updateSubCategory(this.details)
                .then((details) => {
                    this.toastr.success('Category updated successfully');
                    this.$state.go('resourceSubCategory', {});
                }).catch((err)=> {
                    this.disableButtons = false;
                    this.toastr.error(err);
                });
            }
        }

        _addSubCategory(){
            this.$state.go('resourceSubCategoryEdit', {
                id: this.details.id,
                resource_id: this.resourceId
            });
        }

        _goBack(){
            this.$state.go('resourceCategory', {
                id: this.resourceId,
                categoryName: this.details.resourceName
            });
        }

    }
};



// WEBPACK FOOTER //
// ./src/app/components/resources/resource-subcategory-details/resource-subcategory-details.component.js